import {GuidesEnum} from 'presentation/constants';
import {PlanTypeEnum} from 'presentation/constants/bookingTypesEnum';
import {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {UseGuideNavigationParams} from './types';
import {useGuideStore} from '../../store/guideStore';

export const useGuideNavigation = ({type}: UseGuideNavigationParams) => {
	const navigate = useNavigate();
	const {setCoordinates} = useGuideStore();

	const handleNavToStateSelection = useCallback(() => {
		setCoordinates(null);

		if (type === PlanTypeEnum.HEALTH) {
			navigate(GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_UF);
			return;
		}

		navigate(GuidesEnum.SERVICE_NETWORK_ODONTO_FLOW_UF);
	}, [type, navigate]);

	const handleNavToHealthGuideFavoritePlaces = useCallback(() => {
		setCoordinates(null);
		navigate(GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_FAVORITE_PLACES_LIST);
	}, [navigate, setCoordinates]);

	return {
		handleNavToStateSelection,
		handleNavToHealthGuideFavoritePlaces,
	};
};
